import React, { useCallback } from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { useToggle } from 'usehooks-ts'

import { useStyles } from '@signavio/ui'

import { Features, LocaleProvider, prependOrg } from '@signavio/effektif-api'
import {
  DevTools,
  ErrorBoundary,
  applicationName,
  useDocumentTitle,
  useLinkSupport,
} from '@signavio/effektif-commons'

import {
  OrganizationThemeProvider,
  SideNavigation,
  SidePanel,
} from '../components'
import AuthenticatedPage from './AuthenticatedPage'
import Session from './Session'
import { GlobalHeader } from '../components/global-header/GlobalHeader'

function Main() {
  useDocumentTitle(applicationName)
  useLinkSupport()

  const [value, toggle, setToggle] = useToggle(false)

  const collapse = useCallback(() => {
    setToggle(false)
  }, [setToggle])

  const styles = useStyles(defaultStyles, {})

  return (
    <DevTools>
      <OrganizationThemeProvider>
        <Session>
          {({ user, organization }) => (
            <LocaleProvider user={user}>
              <Features>
                <div {...styles('header')}>
                  <GlobalHeader />
                </div>
                <SidePanel
                  isOpen={value}
                  onRequestCollapse={collapse}
                  panel={<SideNavigation isOpen={value} toggle={toggle} />}
                >
                  <ErrorBoundary>
                    <div {...styles('contentContainer')}>
                      <Switch>
                        <Route
                          path="/:organization"
                          component={AuthenticatedPage}
                        />

                        <Redirect to={prependOrg('/cases/tasks/inbox')} />
                      </Switch>
                    </div>
                  </ErrorBoundary>
                </SidePanel>
              </Features>
            </LocaleProvider>
          )}
        </Session>
      </OrganizationThemeProvider>
    </DevTools>
  )
}

const defaultStyles = () => {
  return {
    header: {
      position: 'sticky',

      top: 0,
      zIndex: 999,
    },
  }
}

export default Main
